module.exports = __webpack_public_path__ + "b5a065b2f0ca083cecdaf2b6094f92d2.MP3";